export interface IntegrationCredential {
  bearer: string
  expire: string
  login: string
  organization: number
}

export interface ResponseIntegrationCredential {
  integration: IntegrationCredential[]
}

export enum IntegrationTypes {
  GET_INTEGRATION_CREDENTIALS = '@integration/GET_INTEGRATION_CREDENTIALS',
  GET_INTEGRATION_CREDENTIALS_FAILURE = '@integration/GET_INTEGRATION_CREDENTIALS_FAILURE',
  GET_INTEGRATION_CREDENTIALS_SUCCESS = '@integration/GET_INTEGRATION_CREDENTIALS_SUCCESS',
  SET_INTEGRATION_CREDENTIAL = '@integration/SET_INTEGRATION_CREDENTIAL',
  SET_INTEGRATION_CREDENTIAL_FAILURE = '@integration/SET_INTEGRATION_CREDENTIAL_FAILURE'
}

export interface IntegrationsState {
  error: string
  errorRenew: string
  list: IntegrationCredential[]
  loading: boolean
}
